import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Form, Formik, } from "formik";
import { FormCheckbox, FormInput, FormSelector } from "../FormElements";
import { useLocation } from 'react-router-dom'
import BottomButtons from "../VirtualPos/BottomButtons";
import { posConnectionSchema } from "../../../common/validators/posConnectionSchema";
import commonNetwork from "../../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getVPList } from "../../../store/slices/vpListSlice";
import { useDispatch, useSelector } from "react-redux";
import { TbDots } from "react-icons/tb";
import { clearBankMatchSelect } from "../../../store/slices/erpParameterSlice";
import { customerSelectFrom, postMessageTypes } from "../../../constants/postMessageFileds";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import appHelpers from "../../../common/helpers/appHelpers";
import FormObserver from "../FormElements/FormObserver";
import { erpSyncType } from "../../../constants/erpSyncTypes";
import { postWebViewMessage } from "../../../common/helpers/messageHelper";
import { isLogoAppProject } from "../../../common/helpers/globalHelpers";
import { ExtraParams } from "./ExtraParams";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../../store/recoil/tenant/atoms";
import { getNavigationUrl } from "../../../common/helpers/navigationHelpers";

const paymentModalIds = [
    {
        value: 1,
        label: "3D",
    },
    {
        value: 3,
        label: "3D_PAY_HOSTING",
    },
    {
        value: 4,
        label: "3DPay",
    },
    {
        value: 5,
        label: "2DPay",
    },
];

export default function VpInformations({ vpInfo, setVpInfo, isLoading, setIsLoading, bankFields,
    isVpErrorStatus, isVpErrorMessage, isDefaultVp, isCurrentVp, setIsVpSaved,
    switchInstallmentTab, erpcontractcodeOptions}) {
    let { bankId } = useParams();

    const { firmInformations } = useRecoilValue(tenantState);

    const isNetsis = firmInformations.erpType == "NETSIS";

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const goToPosConnectionSettings = getNavigationUrl("/pos-baglanti-ayarlari");
    const { erpParameter, selectedErpBankCode } = useSelector((state) => state.erpParameters);

    const bankErpCodeSelectBoxRef = useRef();
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [posLoading, setPosLoading] = useState(false);
    

    const isReceipt = erpParameter?.netsisParams?.synctypeid == erpSyncType.receipt ? true : false;
    const isFastPayment = erpParameter?.netsisParams?.synctypeid == erpSyncType.fastPayment;
    const isVirement = erpParameter?.logoParams?.synctypeid == erpSyncType.virement;

    useEffect(() => {
        if (bankErpCodeSelectBoxRef.current && selectedErpBankCode?.length > 0) {
            dispatch(clearBankMatchSelect())
            bankErpCodeSelectBoxRef.current.setValue(selectedErpBankCode + "");

        }
    }, [selectedErpBankCode]);

    const alertMessage = (status) => {
        if (status) {
            toast.success("Pos entegrasyonu ayarlarınız kaydedilmiştir.");
        }
        else {
            toast.error("Pos entegrasyonu ayarlarınız kaydedilememiştir!");
        }
    }

    const openCustomerForm = () => {
        var callbackParameters = {
            customerSelectFrom: customerSelectFrom.fromVpInformations
        }
        var messageBody = { requestType: postMessageTypes.getCustomerInfo, requestBody: "", callbackParameters: JSON.stringify(callbackParameters) };
        postWebViewMessage(JSON.stringify(messageBody));
    }

    const openBankListForm = (item) => {
        if (isVirement && isNetsis != true) {
            openCustomerForm();
        } else {
            var messageBody = {
                requestType: postMessageTypes.openErpBankList,
                requestBody: (isReceipt) ? "true" : "false",
                // callbackParameters: JSON.stringify(callBackParams),
            };
            postWebViewMessage(JSON.stringify(messageBody));
        }
    }

    const onSubmitV1 = async (values) => {
        try {
            var url = values?.vpId > 0 ? "/virtualpos/edit-v1" : "/virtualpos-v1"

            setIsLoading(true);
            var params = {
                ...values,
            }

            const res = await commonNetwork.post(url, params);
            setIsLoading(false);
            if (res.isSuccess && values?.vpId > 0) {
                setIsVpSaved(true);
                dispatch(getVPList());
                alertMessage(res.isSuccess ? true : false);
                switchInstallmentTab(res.data, values.vpDisplayName || values.bankName);
                navigate(goToPosConnectionSettings);
            } else if (res.isSuccess) {
                setIsVpSaved(true);
                dispatch(getVPList());
                alertMessage(res.isSuccess ? true : false);
                switchInstallmentTab(res.data, values.vpDisplayName || values.bankName);
                navigate(goToPosConnectionSettings);
            }
            setPosLoading(false);
            toast.error(res.data.message ?? res.errorMessge);
        } catch (error) {
            alert(error);
        }
    }

    

    return (
        <div className="w-full flex flex-col">
            <div className="flex flex-col items-center justify-center">
                {vpInfo.modalId === null ? (
                    <div className="w-full text-error-text">
                        <div className="m-4 p-4 bg-white shadow-md flex flex-row justify-center items-center">
                            Bir hata meydana geldi.Entegrasyon icin yetkili ile iletisime
                            geciniz.
                        </div>
                    </div>
                ) : isLoading ? (
                    <div className="w-full text-warning-text">
                        <div className="m-4 p-4 bg-white shadow-md flex flex-row justify-center items-center">
                            Yükleniyor...
                        </div>
                    </div>
                ) : isVpErrorStatus ? (
                    <div className="w-full text-error-text">
                        <div className="m-4 p-4 bg-white shadow-md flex flex-row justify-center items-center">
                            {isVpErrorMessage}
                        </div>
                    </div>
                ) : (
                    <Formik
                        initialValues={vpInfo}
                        enableReinitialize
                        validationSchema={posConnectionSchema}
                        onSubmit={onSubmitV1}
                    >
                        {({
                            values,
                            setFieldValue,
                            errors,
                            touched,
                        }) => (
                            <>
                                <Form className="w-full">
                                    <FormObserver
                                        watch={(val) => {

                                            setVpInfo(val);
                                        }}
                                    />
                                    <div className="m-4 p-4 bg-white shadow-md rounded-md">
                                        <div className="flex flex-row justify-start">
                                            <span className="font-bold text-contrast-90">
                                                Genel Ayarlar ve Bağlantı Bilgileri
                                            </span>
                                        </div>
                                        <div className="grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-4 xl:grid-cols-4 mt-3">
                                            <div className="col-span-2 mt-3 space-y-2">
                                                <FormInput
                                                    label="Banka Adı"
                                                    name="bankName"
                                                    type="text"
                                                    disabled
                                                    className="text-contrast-50"
                                                    value={values.bankName}
                                                />
                                                <FormInput
                                                    name="bankId"
                                                    type="number"
                                                    className="hidden"
                                                    value={Number(bankId)}
                                                />
                                                {/* <FormInput
                                                    label="Ödeme Altyapı Tipi"
                                                    name="modalName"
                                                    type="text"
                                                    disabled
                                                    className="text-contrast-50"
                                                    value={values.modalName}
                                                />
                                                <FormInput
                                                    name="modalId"
                                                    type="number"
                                                    className="hidden"
                                                    value={values.modalId}
                                                /> */}
                                                <FormSelector
                                                    options={paymentModalIds}
                                                    name="modalId"
                                                    placeholder="Ödeme Altyapı Tipi"
                                                    label="Ödeme Altyapı Tipi Seçiniz"
                                                    onChange={setFieldValue}
                                                    value={paymentModalIds.find(s => s.value == values.modalId)}
                                                />
                                                <FormInput
                                                    label="Ödeme Altyapısı Adı"
                                                    name="vpDisplayName"
                                                    required
                                                    type="text"
                                                    maxLength={51}
                                                />
                                                <FormInput
                                                    label={isVirement ? "Virman Müşteri Kodu" : "ERP Banka Kodu"}
                                                    name="erpBankCode"
                                                    type="text"
                                                    ref={bankErpCodeSelectBoxRef}
                                                    clearable
                                                    maxLength={51}
                                                    onClear={() => {
                                                        bankErpCodeSelectBoxRef.current.setValue("");
                                                    }}
                                                    rightIcon={isLogoAppProject() &&
                                                        <div className="flex items-center" >
                                                            <TbDots
                                                                onClick={() => openBankListForm()}
                                                                className="justify-end sm:block h-6 w-6 text-black hidden cursor-pointer  "
                                                                aria-hidden="true"
                                                                color="#0090FF"
                                                            />
                                                        </div>
                                                    }
                                                />
                                                {(isFastPayment && isNetsis) ? (
                                                    <div className="">
                                                        <FormSelector
                                                            options={erpcontractcodeOptions}
                                                            name="erpContractCode"
                                                            placeholder="Sözleşme Kodu Seçiniz"
                                                            label="Sözleşme Kodu"
                                                            onChange={setFieldValue}
                                                            value={erpcontractcodeOptions.find(s => s.value == values.erpContractCode)}
                                                        />
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div className="col-span-2 mt-3 space-y-2">
                                                {bankFields.merchantId && (
                                                    <FormInput
                                                        label={bankFields.merchantId}
                                                        name="merchantId"
                                                        type="text"
                                                        value={values.merchantId}
                                                        required
                                                        maxLength={251}
                                                    />
                                                )}
                                                {bankFields.terminalId && (
                                                    <FormInput
                                                        label={bankFields.terminalId}
                                                        name="terminalId"
                                                        type="text"
                                                        value={values.terminalId}
                                                        required
                                                        maxLength={251}
                                                    />
                                                )}
                                                {bankFields.username && (
                                                    <FormInput
                                                        label={bankFields.username}
                                                        name="username"
                                                        type="text"
                                                        value={values.username}
                                                        required

                                                    />
                                                )}
                                                {bankFields.password && (
                                                    <FormInput
                                                        label={bankFields.password}
                                                        name="password"
                                                        type={isRevealPwd ? "text" : "password"}
                                                        value={values.password}
                                                        required
                                                        rightIcon={
                                                            <FontAwesomeIcon
                                                                onClick={() => setIsRevealPwd(!isRevealPwd)}
                                                                icon={isRevealPwd ? faEye : faEyeSlash} />
                                                        }
                                                    />
                                                )}
                                                {bankFields.storeKey && (
                                                    <FormInput
                                                        label={bankFields.storeKey}
                                                        name="storeKey"
                                                        type="text"
                                                        value={values.storeKey}
                                                        required={vpInfo.modalId == 5 ? false : true}

                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div>
                                            <div className="mt-6">
                                                <div className="flex gap-[20px]">
                                                    <FormCheckbox
                                                        label="Test Ortamı Mı?"
                                                        name="istest"
                                                        id="istest"
                                                        type="checkbox"
                                                        className="col-span-1"
                                                        onChange={setFieldValue}
                                                        value={values.istest}
                                                    />
                                                    {/* <FormCheckbox
                                                            label="Taksit Var Mı?"
                                                            name="isinstallment"
                                                            id="isinstallment"
                                                            type="checkbox"
                                                            className="col-span-1"
                                                            onChange={setFieldValue}
                                                            value={values.isinstallment}
                                                        /> */}
                                                    {
                                                        (!isDefaultVp || isCurrentVp) && (
                                                            <div className="col-span-2">
                                                                <FormCheckbox
                                                                    label="Varsayılan Ödeme Yöntemi Mi?"
                                                                    name="isDefault"
                                                                    id="isDefault"
                                                                    type="checkbox"
                                                                    onChange={setFieldValue}
                                                                    value={values.isDefault}
                                                                />
                                                            </div>
                                                        )
                                                    }
                                                    <FormCheckbox
                                                        label="Ekstra Parametre Var Mı?"
                                                        name="extraParams"
                                                        id="extraParams"
                                                        type="checkbox"
                                                        onChange={setFieldValue}
                                                        value={values.extraParams}
                                                    />
                                                    {firmInformations.isCurrency === true ? <FormCheckbox
                                                        label="Dövizli Pos Mu?"
                                                        name="isMultipleCurrency"
                                                        id="isMultipleCurrency"
                                                        type="checkbox"
                                                        onChange={setFieldValue}
                                                        value={values.isMultipleCurrency}
                                                    /> : ""}
                                                    <FormCheckbox
                                                        label="Üretici Kart Desteği Var Mı?"
                                                        name="isManufacturer"
                                                        id="isManufacturer"
                                                        type="checkbox"
                                                        onChange={setFieldValue}
                                                        value={values.isManufacturer}
                                                    />
                                                </div>
                                            </div>
                                            <ExtraParams bankId={values.bankId} extraParams={values.extraParams} values={values} />
                                        </div>
                                    </div>
                                    <BottomButtons isLoading={posLoading}/>
                                </Form>
                                {/* <pre>{JSON.stringify(errors, null, 2)}</pre> */}
                            </>
                        )}
                    </Formik>
                )}
            </div>
        </div>
    );
}
